<template>
  <el-dialog id="editConstDialog" title="修改系统常量" :visible.sync="isShowTemp" width="900px">

    <el-form  :model="constData" ref="editConstForm" label-width="80px" class="demo-dynamic">
      <el-form-item prop="key" label="常量名称" :rules="[
      { required: true, message: '请输入常量名称', trigger: 'blur' },
    ]">
        <el-input class="eb-input" v-model="constData.key"></el-input>
      </el-form-item>
      <div class="saveConstDialogFormItemBox" v-for="(valueData, index) in constData.value" :key="index">
        <el-form-item label="键名" class="saveConstDialogFormItem one">
          <el-input type="textarea" class="eb-textarea" v-model="valueData.key"></el-input>
        </el-form-item>

        <el-form-item label="键值" class="saveConstDialogFormItem two">
          <el-input type="textarea" v-model="valueData.value"></el-input>
        </el-form-item>

        <el-form-item class="saveConstDialogFormItem three">
          <el-button class="eb-button-orange  eb-button-small" @click.prevent="removeSaveData(valueData)">删除</el-button>
        </el-form-item>

      </div>
      <el-form-item>
        <el-button class="eb-button-orange  eb-button-small" @click="addSaveData">添加行数</el-button>
        <!-- <el-button class="eb-button-orange  eb-button-small" @click="resetForm('editConstForm')">重置</el-button> -->
      </el-form-item>
    </el-form>
    <div class="eb-button-group">
      <el-button class="eb-button-orange  eb-button-big eb-button-group-btn" @click="isShowTemp = false">取 消</el-button>
      <el-button class="eb-button-orange  eb-button-big eb-button-group-btn" @click="submitForm('editConstForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getConstByKey } from '@/services/const-service';
export default {
  name: 'editConstDialog',
  props: {
    isShow: {
      default: false
    },
    chooseData: {
      default: function() {
        return {
          key: '',
          value: []
        };
      }
    }
  },
  data() {
    return {
      constData: {
        key: '',
        value: []
      }
    };
  },
  watch: {
    chooseData: function() {
      this.init();
    }
  },
  computed: {
    isShowTemp: {
      get: function() {
        return this.isShow;
      },
      set: function(val) {
        this.$emit('update:isShow', val);
      }
    }
  },
  created() {
    if (this.chooseData.key) {
      this.init();
    }
  },
  methods: {
    async init() {
      try {
        let { data } = await getConstByKey(this.chooseData.key);
        if (data.returnCode === '01') {
          if (data.const) {
            let json = {
              key: '',
              value: []
            };
            if (data.const && data.const.value) {
              let value = JSON.parse(data.const.value);
              let arr = [];
              for (var i in value) {
                var valJson = {};
                valJson.key = '' + i;
                valJson.value = '' + value[i];
                arr.push(valJson);
                json.value.push(valJson);
              }
              json.key = this.chooseData.key;
            }
            this.constData = json;
          }
        } else {
          this.$message.error('获取通知信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let constData = this.constData;
          let json = {};
          if (constData && constData.value) {
            for (var i = 0; i < constData.value.length; i++) {
              if (constData.value[i].key) {
                json[constData.value[i].key] = constData.value[i].value;
              }
            }
          }
          let emitData = {
            key: this.constData.key,
            value: JSON.stringify(json)
          };
          if (emitData.value !== '{}') {
            this.$emit('handleEditConst', emitData);
          } else {
            this.$message.error('请输入键和值');
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addSaveData: function() {
      this.constData.value.push({
        value: '',
        key: ''
      });
    },
    removeSaveData: function(item) {
      var index = this.constData.value.indexOf(item);
      if (index !== -1) {
        this.constData.value.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="less">
#editConstDialog {
  .saveConstDialogFormItemBox {
    display: flex;
  }
  .saveConstDialogFormItem {
  }
  .one {
    flex: 1;
  }
  .two {
    flex: 2;
  }
  .three {
    flex: 1;
  }
}
</style>
